import axios from 'axios';
import { ROOT_API_URL } from '../../../api-config';
import { loader, toastr } from '../CommonActions';
import { auth } from '../../../services/auth.service';

export const GET_ALL_SIZES = 'GET_ALL_SIZES';
export const SAVE_SIZE = 'SAVE_SIZE';
export const DELETE_SIZE = 'DELETE_SIZE';

const successColor = 'success';
const errorColor = 'danger';

//const warningColor = 'warning';

export function fetchAllSizes() {
	return function(dispatch) {
		dispatch(loader(true));
		axios
			.get(`${ROOT_API_URL}/ManageSizes/GetSizeOptions`, { headers: auth.authHeader() })
			.then((response) => {
				dispatch({
					type: GET_ALL_SIZES,
					payload: response.data
				});
				dispatch(loader(false));
			})
			.catch((response) => {
				var err = response && response.data ? response.data.message : 'Network Connection Error';
				dispatch(loader(false));
				dispatch(toastr(true, err, errorColor));
			});
	};
}

export function saveSize(model) {
	return function(dispatch) {
		dispatch(loader(true));
		axios
			.post(`${ROOT_API_URL}/ManageSizes/SaveSize`, model, { headers: auth.authHeader() })
			.then(function(response) {
				if (response && response.data && response.data.issuccess) {
					dispatch({
						type: SAVE_SIZE,
						payload: response.data.sizes
					});
					var success = response && response.data ? response.data.message : 'Size Created Successfully';
					dispatch(toastr(true, success, successColor));
				} 
				dispatch(loader(false));
			})
			.catch((response) => {
				var err = response && response.data ? response.data.message : 'Network Connection Error';
				dispatch(loader(false));
				dispatch(toastr(true, err, errorColor));
			});
	};
}

export function deleteSize(model) {
	return function(dispatch) {
		dispatch(loader(true));
		axios
			.post(`${ROOT_API_URL}/ManageSizes/DeleteSize`, model, { headers: auth.authHeader() })
			.then(function(response) {
				if (response && response.data && response.data.issuccess) {
				dispatch({
					type: DELETE_SIZE,
					payload: response.data.sizes
				});
				var success = response && response.data ? response.data.message : 'Size Deleted Successfully';
					dispatch(toastr(true, success, successColor));
				} 
				dispatch(loader(false));
			})
			.catch((response) => {
				var err = response && response.data ? response.data.message : 'Network Connection Error';
				dispatch(loader(false));
				dispatch(toastr(true, err, errorColor));
			});
	};
}
